module.exports = __webpack_public_path__ + "static/media/es-ca.a35e6a4a.svg";